import styled, { css } from 'styled-components';
import {
  getTextType,
  getSpace,
  borderClipPath,
  px2rem,
  mq,
  getTransition
} from '../../../stylesheets/tools';

const disabledColor = 'gray';

const StyledTextarea = styled.div`
  position: relative;
  ${getTextType('subline')}
  text-transform: uppercase;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  .textarea__wrapper {
    position: relative;
    width: 100%;
    padding: 70px 20px 20px;
    cursor: text;
    display: flex;
    flex-direction: column;
    gap: ${getSpace('xxs')};
    ${borderClipPath('#000', '#fff')}
  }

  textarea {
    position: relative;
    display: block;
    width: 100%;
    min-height: 120px;
    background: none;
    border: none;
    padding: 0;
    z-index: 1;
    outline: 0;
    resize: vertical;

    &::placeholder {
      text-transform: uppercase;
    }
  }

  .textarea__label {
    margin-top: -45px;
    z-index: 1;
    display: flex;
    align-items: flex-end;
  }

  .textarea__required {
    font-family: arial-black;
    font-size: ${px2rem('20px')};
    display: inline-block;
    align-self: flex-start;

    ${mq('m')} {
      font-size: ${px2rem('30px')};
    }
  }

  .textarea__desc {
    width: 100%;
    margin-top: ${px2rem('12px')};

    p {
      ${getTextType('copySmall', 'international')};
      text-transform: capitalize;
    }
  }

  .textarea__warn {
    position: absolute;
    top: 100%;
    left: 0;
    font-size: 12px;
    color: red;
    visibility: hidden;
    opacity: 0;
    padding: 10px 20px;
    ${getTransition('inputError')}
  }

  ${props =>
    props.error &&
    css`
      .textarea__wrapper {
        ${borderClipPath('red', '#fff')}
      }

      .textarea__warn {
        visibility: visible;
        opacity: 1;
      }
    `}

  ${props =>
    props.active &&
    props.theme.siteTheme &&
    css`
      .textarea__wrapper {
        ${borderClipPath(props.theme.siteTheme.focusColor, '#fff')}
      }
    `}

  ${props =>
    props.disabled &&
    css`
      .textarea__wrapper {
        cursor: default;
        ${borderClipPath(disabledColor, '#fff')}
      }

      .textarea__label {
        color: ${disabledColor};
      }
    `}
`;

export default StyledTextarea;
